import React from 'react';
import PhoneInput, { isValidPhoneNumber, type Value } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface GPhoneInputProps {
  label?: string;
  value: Value | undefined;
  onChange: (value: string) => void;
  className?: string;
  required?: boolean;
  error?: string;
  placeholder?: string;
}

const GPhoneInput: React.FC<GPhoneInputProps> = ({
  label,
  value,
  onChange,
  className = '',
  required = false,
  error,
  placeholder = 'Phone number',
}) => {
  const inputId = React.useId();

  return (
    <div className="mb-5">
      {label && (
        <label htmlFor={inputId} className="block text-white/75 text-[14px] font-bold uppercase tracking-widest mb-[8px]">
          {label}
          {!required && <span className="text-white/40 text-[11px] ml-2 normal-case tracking-normal font-normal">(optional)</span>}
        </label>
      )}
      <div className="relative group">
        <PhoneInput
          international
          defaultCountry="US"
          value={value}
          onChange={(val: Value | undefined) => onChange(val || '')}
          placeholder={placeholder}
          className={`g-phone-input px-5 py-[14px] bg-white/[0.06] border border-white/[0.1] rounded-[12px] text-white text-[15px] font-medium placeholder-white/25 focus-within:border-[#4DBDFF]/50 focus-within:bg-white/[0.1] focus-within:shadow-[0_0_20px_rgba(0,134,211,0.12),inset_0_0_20px_rgba(0,134,211,0.05)] transition-all duration-300 ${error ? 'border-red-500/50' : ''} ${className}`}
        />
      </div>
      {error && (
        <p className="text-red-400 text-[12px] mt-1">{error}</p>
      )}
    </div>
  );
};

export { isValidPhoneNumber };
export default GPhoneInput;
